import { createFileRoute } from '@tanstack/react-router'

import Breadcrumbs from '@/containers/breadcrumbs'

import Content from '@/components/content'
import PageHeader from '@/components/pageHeader'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import PlaygroundNavigation from './-components/playgroundNavigation'

export const Route = createFileRoute('/_authed/$client_code/playground/')({
    component: Playground,
})

function Playground() {
    const { client_code } = Route.useParams()
    useSetBreadcrumbs([
        {
            to: '/$client_code/playground',
            text: 'Playground',
            params: { client_code },
        },
    ])

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader title="Playground" />
                <PlaygroundNavigation active="text" />

                <div className="mb-4">
                    <h1>Heading one</h1>
                    <h2>Heading two</h2>
                    <h3>Heading three</h3>
                    <h4>Heading four</h4>
                    <h5>Heading five</h5>
                    <h6>Heading six</h6>
                    <p>Paragraph</p>
                    <ul>
                        <li>Unordered</li>
                        <li>List</li>
                    </ul>
                </div>
            </Content>
        </>
    )
}
